import { PROJECT_DIRECTORY_ARCHIVED_PAGE } from '@townsquare/config/routes';
import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';

import ProjectDirectoryQuery, {
	ProjectDirectoryQuery as ProjectDirectoryQueryType,
} from '../components/__generated__/ProjectDirectoryQuery.graphql';

export const projectDirectoryResource = createRelayResource<ProjectDirectoryQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		return {
			query: ProjectDirectoryQuery,
			variables: {
				aaid: context.user?.accountId,
				workspaceId: context.workspace?.globalId,
				workspaceUuid: context.workspace?.UUID ?? '',
				includeArchived: routerContext.route.name === PROJECT_DIRECTORY_ARCHIVED_PAGE,
			},
		};
	},
});
